import { CRM_OBJECT_LIST } from '../../constants/Tools';
/**
 * Converts a legacy Communication Summary action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertCommunicationSummaryAction = inAppActionLegacy => {
  return {
    name: CRM_OBJECT_LIST,
    arguments: {
      '@type': 'map',
      value: {
        searchRequest: {
          '@type': 'map',
          value: {
            query: {
              '@type': 'string',
              value: inAppActionLegacy.email
            },
            objectTypeId: {
              '@type': 'map',
              value: {
                innerId: {
                  '@type': 'integer',
                  value: 1 // Contact object type ID
                },
                metaType: {
                  '@type': 'string',
                  value: 'HUBSPOT'
                }
              }
            },
            filterGroups: {
              '@type': 'list',
              value: [{
                '@type': 'map',
                value: {
                  filters: {
                    '@type': 'list',
                    value: [{
                      '@type': 'map',
                      value: {
                        property: {
                          '@type': 'string',
                          value: 'email'
                        },
                        operator: {
                          '@type': 'string',
                          value: 'EQ'
                        },
                        value: {
                          '@type': 'string',
                          value: inAppActionLegacy.email
                        }
                      }
                    }]
                  }
                }
              }]
            },
            sorts: {
              '@type': 'list',
              value: []
            },
            properties: {
              '@type': 'list',
              value: [{
                '@type': 'string',
                value: 'name'
              }]
            },
            associations: {
              '@type': 'list',
              value: [{
                '@type': 'map',
                value: {
                  associationTypeId: {
                    '@type': 'integer',
                    value: 9
                  },
                  category: {
                    '@type': 'string',
                    value: 'HUBSPOT_DEFINED'
                  }
                }
              }]
            }
          }
        }
      }
    }
  };
};